export const currentProject = (state) => state.currentProject
export const projectBrowserPopup = (state) => state.projectBrowserPopup
export const projects = (state) => state.projects
export const showWidgetGrid = (state) => state.showWidgetGrid
export const projectQ = (state) => state.projectQ
export const wikiProjectId = (state) => state.wikiProjectId
export const historyOpts = (state) => state.historyOpts
export const showProjectList = (state) => state.showProjectList
export const selectedQa = (state) => state.selectedQa
export const dashboardEnabled = (state) => state.dashboardEnabled
export const projectboardEnabled = (state) => state.projectboardEnabled
export const otfComment = (state) => state.otfComment



// WEBPACK FOOTER //
// ./src/store/modules/project/getters.js